import { createContext, useContext, useState } from "react";

const QuoteContext = createContext();

export const useQuote = () => useContext(QuoteContext);

export const QuoteProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const openQuote = (product) => {
    setSelectedProduct(product);
    setIsOpen(true);
  };

  const closeQuote = () => {
    setIsOpen(false);
    setSelectedProduct(null);
  };

  return (
    <QuoteContext.Provider
      value={{ isOpen, selectedProduct, openQuote, closeQuote }}
    >
      {children}
    </QuoteContext.Provider>
  );
};

